import PickupOrderFwd from '../models/PickupOrderFwd';
import OrderDashboard from '../models/OrderDashboard';
import OrderWhs from '../models/OrderWhs';
import moment from 'moment';
const STATUS_DELIVERED = 0;
const STATUS_NO_SCHEDULE = 1;
const STATUS_ETA = 2;
const STATUS_CHK_IN = 3;
const STATUS_TRUCK_ON_DOCK = 4; 
const STATUS_SUSPENDED = 5;

function truckStatusTime(rowData: OrderDashboard | PickupOrderFwd | OrderWhs): string {

  const formatTruckStatusTime = (time: { days: number; hours: number; minutes: number; past: boolean }) => {

    if (time.days && time.days > 1) {
      return `${time.days} days`; 
    }

    if (time.days && time.days === 1) {
      return `${time.days} day`;
    }

    if (!time.days) {
      return `${time.hours < 10 ? '0' : ''}${time.hours}:${time.minutes < 10 ? '0' : ''}${time.minutes}`;
    }
  }

  if (rowData.truck_status.type === STATUS_DELIVERED) {
    if ((rowData as any).order_type === 'go') {
      return 'Delivered to Customs – Pending Clearance';
    }

    if(rowData.truck_status.fully_returned)
      return `Drop off order returned ${formatTruckStatusTime(rowData.truck_status.time)}`;
    
    const minutes = rowData.wait_time ? rowData.wait_time.minutes % 60 : null;
    const minutesFull = minutes && minutes.toString().length === 1 ? `0${minutes}` : minutes;
    const hours = rowData.wait_time && rowData.wait_time.hours.toString().length === 1 ? `0${rowData.wait_time.hours}`: rowData.wait_time ? rowData.wait_time.hours : '';
    const timestamp = rowData.wait_time ?  ` WT: ${hours}:${minutesFull}h` : '';
    return `${moment(rowData.delivered_date).format('DD MMM').toUpperCase()} -${rowData.delivered_time ? rowData.delivered_time.substring(0,2).toUpperCase() + ':' + rowData.delivered_time.substring(2,4).toUpperCase() : ''} ${timestamp}`;
  } 

  if (rowData.truck_status.type === STATUS_TRUCK_ON_DOCK) {
    return `Truck on Dock ${formatTruckStatusTime(rowData.truck_status.time)}`;  
  }  

  if (rowData.truck_status.type === STATUS_CHK_IN) {
    return `Chk in ${formatTruckStatusTime(rowData.truck_status.time)}`;
  }

  if (rowData.truck_status.type === STATUS_SUSPENDED) {
    return `Suspended - ${rowData.suspension_reason}`;
  }

  if (rowData.truck_status.type === STATUS_ETA && rowData.truck_status.time.past) {
    return `Truck delay ${formatTruckStatusTime(rowData.truck_status.time)}`;
  }

  if (rowData.truck_status.type === STATUS_ETA && !rowData.truck_status.time.past) {
    return `ETA in ${formatTruckStatusTime(rowData.truck_status.time)}`;
  }

  return "No schedule";
};

export {
  truckStatusTime
}